import { Field, Layout, Select } from "@introist/react-foundation/v2";
import { TextInput } from "../../../../components/atoms";
import { ConnectFormProps } from "../../views/DataSourceConnectionSetupView/steps/DataSourceConnectionForm";
import { useConnectAccount } from "../../../connectedaccounts";

import { SharepointFileSelector } from "./SharepointFileSelector";

type SharepointSheetConfig = {
  linkedAccountId: string;
  identifier: string;
  sheetName: string;
};
export const SharepointConnectForm = ({ values, onChange }: ConnectFormProps) => {
  const credentials = (values?.credentials as SharepointSheetConfig) || {
    linkedAccountId: "",
    identifier: "",
    sheetName: ""
  };

  const { sharepointAccounts } = useConnectAccount();

  return (
    <Layout.Group vertical gap="xLarge">
      <TextInput label="Name" value={values?.name} onChange={name => onChange({ name })} />
      <Field title="Sharepoint account">
        <Select
          variant="filled"
          style={{ width: "100%" }}
          options={(sharepointAccounts ?? []).map(a => ({ key: a.id, title: a.name }))}
          placeholder="Select Sharepoint account"
          value={credentials.linkedAccountId}
          onSelect={opt =>
            onChange({
              credentials: {
                ...credentials,
                linkedAccountId: opt.key
              }
            })
          }
        />
      </Field>
      <Field title="File">
        <SharepointFileSelector
          onSelect={identifier =>
            onChange({
              credentials: {
                ...credentials,
                identifier
              }
            })
          }
          accountId={credentials.linkedAccountId}
          value={credentials.identifier}
        />
      </Field>
      <TextInput
        value={credentials.sheetName}
        label="Sheet name"
        onChange={sheetName =>
          onChange({
            credentials: {
              ...credentials,
              sheetName
            }
          })
        }
      />
    </Layout.Group>
  );
};
